import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BASEURL_POLYMER, SUB_PATH_BASIC } from '../../utils/api'
import config from '../../config'
import { PaymentSuccessDetailsProps } from '../../pages/application-coo-stage-c/stage-c-success'
interface QueryParams {
  application_uuid: string
  singpass_token: string
}
export const paymentInfoApi = createApi({
  reducerPath: 'paymentInfoApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASEURL_POLYMER,
  prepareHeaders:(headers,{getState})=>{
    headers.set("Access-Control-Request-Method", "GET");
    headers.set("X-Content-Type-Options", "nosniff");
    headers.set("x-api-key", `${config.xApiKey}`);
  }}),
  endpoints: (builder) => ({
    getPaymentInfo: builder.query<PaymentSuccessDetailsProps, QueryParams>({
      query: (queryParams: QueryParams) => ({
        method: "GET",
        url:`${SUB_PATH_BASIC}/payment-info?applicationUuid=${queryParams.application_uuid}`,
        headers: {
          Authorization: `Bearer ${queryParams.singpass_token}`
        },
      }),
      keepUnusedDataFor:1,
    }),
   
  }),
})

export const { useGetPaymentInfoQuery } = paymentInfoApi

